/* eslint-disable no-param-reassign */
import {
    Component, Input, OnInit, ViewEncapsulation,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MspotService } from '../../../application/services/mspot.service';
import { ApiMSpot } from '../../../domain/models/api-marketing.models';

import { ProcessInterpolationOnStringPipe } from '@shared/pipes/process-interpolation-on-string.pipe';

@Component({
    selector: 'mspot',
    templateUrl: './mspot.component.html',
    styleUrls: ['./mspot.component.scss'],
    // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
    encapsulation: ViewEncapsulation.None,
})
export class MspotComponent implements OnInit {
    @Input() public name: string;

    @Input() public templateData: unknown;

    public html$: Observable<ApiMSpot>;

    public spotRendered = '';

    constructor(
        private readonly sanitizer: DomSanitizer,
        private readonly mspotService: MspotService,
        private readonly processInterpolationOnStringPipe: ProcessInterpolationOnStringPipe
    ) {}

    public ngOnInit(): void {
        this.html$ = this.mspotService.getMspot(this.name).pipe(map((mspot) => {
            mspot.value = mspot.value.replace(/\${text\(/g, '{{');
            mspot.value = mspot.value.replace(/'\)}/g, "'|t}}");
            if (this.templateData) {
                // necesario para las condiciones legales de Turquia que tiene valores dinamicos
                this.spotRendered = this.processInterpolationOnStringPipe.transform(mspot.value, this.templateData);
            } else {
                this.spotRendered = mspot.value;
            }
            return this.transform(this.spotRendered);
        }));
    }

    private transform(htmlString: Record<string, unknown> | string): any {
        const value = typeof htmlString === 'string' ? htmlString : JSON.stringify(htmlString);

        return this.sanitizer.bypassSecurityTrustHtml(value);
    }
}
